import OriginalLayout from './layout';
import Sider from './Sider';
import LeftSider from './LeftSider';
import { AppLayoutContext, DefaultAppLayoutProvider } from './AppLayoutContext';
var Layout = OriginalLayout;
Layout.Sider = Sider;
Layout.LeftSider = LeftSider;
Layout.AppLayoutContext = AppLayoutContext;
Layout.DefaultAppLayoutProvider = DefaultAppLayoutProvider;
export default Layout;